/**
 * Общая точка входа
 * для события изменения размеров экрана.
 *
 * NOTE: Событие на практике происходит редко
 * (например, поворот планшета или телефона, или равзернуть окно на полный экран на десктопе),
 * поэтому мы будем "выполнять" его с помощью debouncer
 * (отложенное выполнение).
 */
itsoftApp.createModule("windowResize", function () {

    // Локальные переменные
    var module = this;
    var events = [];
    var $window = itsoftApp.commonVars.$window;


    /**
     * Основной обработчик,
     * который проходит по всем функциям из массива events
     * и выполняет их.
     *
     * Вызываем обработчик через debouncer (задержка по выполнению),
     * чтобы функции из массива не вызывались слишком часто.
     */
    var resizeController = itsoftApp.utils.debouncer(function () {
        if (!events.length) {
            return;
        }

        var f, i, len;

        if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth) {
            itsoftApp.utils.getViewportSize();
        }

        if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewHeight) {
            itsoftApp.utils.getViewportHeight();
        }

        if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight) {
            itsoftApp.utils.getHeaderHeight();
            itsoftApp.utils.getHeaderFixedHeight();
            itsoftApp.utils.getHeaderStaticHeight();
        }

        if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
            itsoftApp.utils.getDisclaimerHeight();
        }

        if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.cookieHeight) {
            itsoftApp.utils.getCookieHeight();
        }

        for (i = 0, len = events.length; i < len; i++) {
            f = events[i];
            f();
        }
    });


    /**
     * Добавление переданной функции в массив всех функций,
     * которые будут вызваны при срабатывании события "resize" окна браузера.
     *
     * @param {function} func
     */
    var addEvent = function (func, name) {
        if (typeof func !== "function") {
            return;
        }

        const method = function(action) {
            if (action) {
                const index = events.indexOf(method);
                if (index !== -1) {
                    events.splice(index, 1);
                    DEBUG && console.log(`${name} удалён`);
                }
            } else {
                func();
            }
        };

        events.push(method);
        DEBUG && console.log("[module windowResize] function added, count of functions to init now: " + events.length);

        return method;
    };


    // Привязка события и обработчика
    $window.addEventListener("resize", resizeController);


    // Доступ к фукциям
    // текущего модуля
    module.addEvent = addEvent;
});